<template>
  <div>
    <h2>429 Rate Limit Exceeded</h2>
    <p>
      It looks like you've exceeded a limit for a particular feature of DoneDone.
      If you believe this is an error, send us a note with the URL you
      are trying to access to our <a href="https://www.donedone.com/help-center">Support Center</a>.
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'RateLimitExceeded',
})
</script>
